export const MAIN_CLASSNAME = "selectable-tag-wrapper"; // used in the scss file but can't inject it so mind if changing
